import React from 'react';
import { Carousel } from 'react-bootstrap';

import { StateLanguage } from '../../../../languages/config/StateLanguage';
import { Product } from '../../../../models/product.model';
import { Service } from '../../../../models/service.model';
import { imageService } from '../../../../scripts/image.value.script';
import { imageProduct } from '../../../../scripts/image.value.script';

import imgServiceDefault from '../../../../assets/images/service.png';
import imgProductDefault from '../../../../assets/images/product.png';

export interface AppInventoryViewDisplayProps {
  inventory: string,
  record: any | Service | Product
};

const AppInventoryViewDisplay: React.FunctionComponent<AppInventoryViewDisplayProps> = ({inventory, record}) => {
  const {lang} = StateLanguage()

  return (
    <div className="card card-flush">
      <div className="card-header pt-3">
        <div className="card-title">
          <h3 className="text-uppercase">{record.display_name}</h3>
        </div>
        <div className="card-toolbar">
          <div className="badge badge-light-info d-inline fs-7">{record.category.display_name}</div>
        </div>
      </div>
      <div className="card-body text-center pt-0">
        { record.photos.length > 0
          ?
          <Carousel fade variant="dark">
            { record.photos.map (( (item: any, index: number) => { return (
              <Carousel.Item key={index} bsPrefix="carousel-item d-flex justify-content-center align-items-center">
                <img src={inventory === "service" ? imageService(item) : imageProduct(item)} className="d-block w-175px h-175px" alt={lang.labels.photography + index} />
              </Carousel.Item>
            )}))}
          </Carousel>
          :
          <div className="symbol symbol-175px">
            <div className="symbol-label">
              <img src={inventory === "service" ? imgServiceDefault : imgProductDefault} className="w-100 h-100" alt={lang.labels.photography} />
            </div>
          </div>
        }
        <div className="text-muted mt-2">{lang.labels[`${inventory}ReferencePictures` as keyof typeof lang.labels]}</div>
      </div>
    </div>
  )
};

export default AppInventoryViewDisplay;
